import { render } from "./net-purchase-table.vue?vue&type=template&id=8a932316&scoped=true"
import script from "./net-purchase-table.vue?vue&type=script&lang=ts"
export * from "./net-purchase-table.vue?vue&type=script&lang=ts"

import "./net-purchase-table.vue?vue&type=style&index=0&id=8a932316&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8a932316"

export default script